import { render, staticRenderFns } from "./AgenceListVue.vue?vue&type=template&id=2677a61a&"
import script from "./AgenceListVue.vue?vue&type=script&lang=js&"
export * from "./AgenceListVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports